import React from "react";
import { Card, Grid } from "@mui/material";
import FormTextTC from "../../../../../components/Forms/FormTextTC";
import { DialogProvider } from "../../../../Upsell/modernTS/JUI/Dialogs";
import FormSwitchTC from "../../../../../components/Forms/FormSwitchTC";
import ApiIdMapping from "./ApiIdMapping";
import MissingApiIdsInExcel from "./MissingApiIdsInExcel";

export default function Eds() {
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card sx={{ p: 4 }}>
        <Grid container spacing={1} style={{ maxWidth: 1400 }}>
          <FormSwitchTC
            name={"apiaccounts__useTest"}
            tDefault={"Gebruik test omgeving"}
            tKey={"vestigingen.form.apiaccounts.label.useTest"}
          />
          <FormTextTC name={"eds_connection__store_id"} tDefault={"Store ID"} tKey={"eds_connection__store_id"} />
        </Grid>

        <MissingApiIdsInExcel />
        <DialogProvider>
          <ApiIdMapping />
        </DialogProvider>
      </Card>
    </div>
  );
}

export type IdRow = {
  composed_id: string;
  article_id: string;
  option_id: string;
};
